import styled from "styled-components";
import { theme } from "../../theme";

export const StyledFooter = styled.footer`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  padding: 34px;
  min-height: 200px;
  background-color: black;
  position: relative;
  margin-top: 24px;
  color: ${theme.textColor.primaryWhite};
  overflow: hidden;
  @media (max-width: 786px) {
    flex-direction: column;
    align-items: center;
    margin-top: 48px;
    padding: 24px !important;
  }

  div.main-row {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 130px;
    padding: 24px 24px 48px 24px;
    width: 100%;
    h1 {
      margin: 0;
    }
    span {
      margin: 8px 0;
      font-size: 14px;
    }
    div {
      display: flex;
      flex-direction: column;
      h2 {
        margin: 0;
      }
      ul {
        list-style: none;
        padding: 0;
        margin: 0;
        li {
          margin: 10px 0;
          a {
            color: ${theme.textColor.secondaryGray};
            text-decoration: none;
            &:hover {
              color: ${theme.textColor.primaryWhite};
              text-decoration: underline;
            }
          }
        }
      }
    }
    div.col-2 {
      margin-left: auto;
    }
    @media (max-width: 786px) {
      flex-direction: column;
      gap: 24px;

      div.col-2 {
        margin-left: unset;
      }
    }
  }
  div.col-1 {
    span {
      color: ${theme.textColor.secondaryGray};
    }
    div.social {
      margin-top: 24px;
      div.social-media {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: row;
        gap: 20px;
        svg {
          display: block;
          margin: 16px 0 10px 0;
          width: 28px;
          height: 28px;
          cursor: pointer;
        }
      }
    }
  }
  div.bottom-row {
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 0.1px solid ${theme.textColor.tertiaryGray};
    position: absolute;
    bottom: 0;
    width: 95%;
    font-size: 12px;
  }
`;
